import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import { CallToActionKind } from '@/types';

import CallToActionContainer from '@/components/common/callToAction/CallToActionContainer';
import InfoCard from '@/components/common/InfoCardList/InfoCard';

import styles from './InfoCardList2.module.scss';
import { ESPOT_LIST_ORIENTATION } from '@/constants/espot';

const InfoCardList2 = ({ list, title, orientation = ESPOT_LIST_ORIENTATION.RIGHT, url, label }) => {
  const router = useRouter();
  const listClassName = [
    styles.list,
    orientation === ESPOT_LIST_ORIENTATION.LEFT && styles.reverse
  ].filter(Boolean).join(' ');

  const hanleClickButtonList = () => {
    router.push(url);
  };

  return list && (
    <div className={styles.container}>
      {title &&
        <div className={styles.title}>
          <div dangerouslySetInnerHTML={{ __html: title }} data-test-id="container-title"/>
          {url && label && (
            <CallToActionContainer kind={CallToActionKind.SECONDARY} className={styles['btn']} onClick={hanleClickButtonList}>
              {label}
            </CallToActionContainer>
          )}
        </div>
      }
      <div className={listClassName}>
        {list.map((item) => (
          <InfoCard
            key={item._id}
            title={{
              content: item.espot.contentTitle,
              customClass: styles.contentTitle
            }}
            desc={{
              content: item.espot.desc,
              customClass: styles.desc
            }}
            img={{
              src: item.espot.img,
              alt: item.espot.alt
            }}
          />
        ))}
      </div>
    </div>
  );
};

InfoCardList2.propTypes = {
  list: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  orientation: PropTypes.oneOf([ESPOT_LIST_ORIENTATION.LEFT, ESPOT_LIST_ORIENTATION.RIGHT]),
  url: PropTypes.string,
  label: PropTypes.string
};

export default InfoCardList2;
